import React from 'react';
import cc from 'classcat';
import { NextPageContext } from 'next';

import { Accordion, Breadcrumbs, CardItem } from '../../../components';
import { useSiteQuery } from '../../../hooks';
import ErrorPage from '../../_error';
import NotFoundPage from '../../404';

import query from './index.graphql';

import styles from './index.module.scss';

interface Props {
  slug: string;
}

const TopicHelp = ({ slug }: Props) => {
  const variables = { search: `topic:${slug}`, slug };
  const [{ data, error }] = useSiteQuery<TopicHelpQuery>({ query, variables });

  if (error) {
    return <ErrorPage statusCode={500} err={error} />;
  }

  const topic = data?.topic;
  const questions = data?.questions;
  const informationGuides = data?.informationGuides;

  const breadcrumbs: BreadcrumbItem[] = [
    { title: 'Help Centre', uri: '/help-centre' },
    { title: `${topic?.title} Help`, uri: `/${topic?.uri}` },
  ];

  if (topic) {
    return (
      <div className={styles.topicHelp}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <div className="sectionWrapper">
          <div className="pageBanner">
            <div className="container">
              <div className="sectionHeading">Help Centre</div>
              <h1>{topic.title!} Help</h1>
              <p>Find answers to our most asked {topic.title!} Questions</p>
            </div>
          </div>
        </div>
        <div className="section">
          <div className="container">
            <div className="row">
              <div className={cc(['col-lg-8 mx-auto', styles.questions])}>
                {questions?.map(
                  (question) =>
                    question && (
                      <Accordion
                        key={question!.uid!}
                        title={question!.title!}
                        slug={question!.slug!}
                        className={styles.question}
                      >
                        <div dangerouslySetInnerHTML={{ __html: question!.body! }} />
                      </Accordion>
                    ),
                )}
              </div>
            </div>
          </div>
        </div>
        {informationGuides && informationGuides?.length > 0 && (
          <div className="section">
            <div className="container">
              <h2 className="center">Information guides</h2>
              <div className="row cardsWrapper">
                {informationGuides?.map((item) => item && <CardItem key={item.uid!} item={item} />)}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return <NotFoundPage />;
};

TopicHelp.getInitialProps = ({ req }: NextPageContext) => ({
  slug: req?.url?.substring(req?.url?.lastIndexOf('/') + 1).replace(/\?.*$/, ''),
});

export default TopicHelp;
